import { VectorProps } from "../types/vectors";

const LogoTithely = ({
  size="128",
  primary="#5bd9a4",
  secondary="#181f36",
}: VectorProps) => (
  <svg width={size} viewBox="0 0 125.11 34.01" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path fill={primary} d="M16.32,17.15c-1.43,0-11.55-7.02,0-17.15,11.51,9.92,1.43,17.15,0,17.15Z"/>
      <path fill={primary} d="M0,14.94v2.25c0,5.87,5.93,8.9,9.38,8.9h5.8v-3.36c0-3.3-4.32-7.78-8.65-7.78H0Z"/>
      <path fill={primary} d="M32.56,14.94v2.03c0,5.87-6.15,9.12-9.6,9.12h-.54c-1.71,0-2.78.26-3.41,1.35-.77,1.31-.82,6.57-.82,6.57h-1.02s.22-7.14.22-7.14v-4.14c0-3.3,4.32-7.78,8.65-7.78h6.53Z"/>
    </g>
    <g>
      <polygon fill={secondary} points="59.48 9.05 45.84 9.05 45.84 12.13 51.12 12.13 51.12 26.57 54.41 26.57 54.41 12.13 59.48 12.13 59.48 9.05"/>
      <rect fill={secondary} x="60.97" y="13.99" width="3.08" height="12.58"/>
      <path fill={secondary} d="M73.62,23.59c-.73.29-1.72.5-2.43.14-.51-.26-.69-.78-.69-1.62v-5.56h3.08v-2.55h-3.08v-3.68h-3.23v3.68h-2.04v2.55h2.04v5.42c0,2.49.58,3.48,2.47,4.48.69.36,1.24.42,2.07.42.53,0,1.64-.22,2.03-.37l-.21-2.9Z"/>
      <path fill={secondary} d="M82.32,13.66c-1.78,0-3.14.81-4.08,2.15v-7.09h-3.08v17.86h3.08v-4.28c.17-4.19,1.33-5.75,3.17-5.75,2.06,0,2.52,1.64,2.52,2.62v7.4h3.08v-7.4c0-5.34-3.06-5.52-4.69-5.52Z"/>
      <path fill={secondary} d="M100.92,21.07h.14c0-3.77-1.11-7.45-6.45-7.45-4.71,0-6.02,3.91-6.02,6.61s1.72,6.61,6.48,6.61c2.11,0,3.5-.57,4.57-1.7.68-.72,1.04-1.5,1.23-2.11l-3.02-.87c0,.37-.62,1.81-2.78,1.81-2.88,0-3.24-2.14-3.29-2.71l-.02-.16s0-.03,0-.04h9.16ZM94.61,16.26c1.07,0,1.85.5,2.39,1.09.32.34.53.81.68,1.3h-5.81c.12-.52.32-1.01.64-1.39.45-.53,1.14-1,2.09-1Z"/>
      <rect fill={secondary} x="108.23" y="8.72" width="3.08" height="17.86"/>
      <circle fill={secondary} cx="62.46" cy="10.11" r="2.07"/>
      <circle fill={secondary} cx="103.99" cy="24.84" r="2.07"/>
      <polygon fill={secondary} points="121.76 13.87 118.74 21.77 115.56 13.87 112.2 13.87 117.12 25.99 115.14 31.17 118.43 31.17 125.11 13.87 121.76 13.87"/>
    </g>
  </svg>
);

export default LogoTithely;
